import { inject, Injectable } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { QCChecklistDialogComponent, QC_CHECKLIST_DIALOG_KEY } from './qc-checklist-dialog.component';
import { QCChecklistDialogConfig } from './model';
import { LocalPreferenceService } from '../../../core/service/local-preference.service';

const DEFAULT_WIDTH = '400px';
const DEFAULT_HEIGHT = '80vh';

@Injectable()
export class QCChecklistDialogService {
    private readonly _dialogService = inject(DialogService);
    private readonly _localPreferenceService = inject(LocalPreferenceService);

    /**
     * Opens the QC Checklist Dialog.
     *
     * @param config - Configuration for the dialog including treatment details and checklist items
     * @returns DynamicDialogRef for handling dialog events
     */
    open(config: QCChecklistDialogConfig): DynamicDialogRef {
        const savedPositionSize = this._localPreferenceService.getDialogPositionSize(QC_CHECKLIST_DIALOG_KEY);

        const dialogConfig: DynamicDialogConfig = {
            data: config,
            header: '质检清单',
            width: savedPositionSize?.width ?? DEFAULT_WIDTH,
            height: savedPositionSize?.height ?? DEFAULT_HEIGHT,
            draggable: true,
            modal: false,
            resizable: true,
            closeOnEscape: false,
            dismissableMask: false,
            closable: false,
            styleClass: 'qc-checklist-dialog-container',
            contentStyle: {
                overflow: 'hidden',
                display: 'flex',
                'flex-direction': 'column',
                padding: '0',
            },
        };

        // Apply saved position if available, otherwise use default left position
        if (savedPositionSize?.left || savedPositionSize?.top) {
            dialogConfig.style = {
                left: savedPositionSize.left ?? undefined,
                top: savedPositionSize.top ?? undefined,
                transform: 'none',
            };
            dialogConfig.maskStyleClass = 'qc-checklist-dialog-mask-restored';
        } else {
            dialogConfig.position = 'left';
        }

        return this._dialogService.open(QCChecklistDialogComponent, dialogConfig);
    }
}
